import axios from 'axios';
import Cookies from 'js-cookie';
import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col, Input, Button, Alert, Toast, ToastHeader, ToastBody } from 'reactstrap';
import styled from 'styled-components';
import CryptoJS from 'crypto-js';
import LoadingPage from './LoadingPage';
import {FaPowerOff} from 'react-icons/fa6';
import {ReactComponent as KataIcon} from '../../assets/kata-icon.svg';
import { LoginTitle } from '../login/LoginPage';

const ToastContainer = styled.div`
    position: absolute;
    bottom: 35px;
    right: 20px;
    color: #fff;

    & .toast {
        background: #ff000059;

        & .toast-header {
            background: #ff000059;
            color: #fff;
        }
    }
`

const ChatContainer = styled(Container)`
    height: 100vh;
    padding: 20px;
    text-align: left;
    display: flex;
    flex-direction: column;
    & button {
        @media (max-width: 600px) {
            margin-top: 10px;
        }
    }
`;

const MessageContainer = styled.div`
    display: flex;
    flex-direction: row;
    background-color: #d8fbd2;
    color: #333333;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 10px;
    width: fit-content;
    max-width: 70%;
    margin-left: auto;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const MessageContainerBot = styled.div`
    display: flex;
    flex-direction: row;
    background-color: #ffffff;
    color: #333333;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 10px;
    width: fit-content;
    max-width: 70%;
    margin-right: auto;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Text = styled.div`
    margin-right: 30px;
    text-align: justify;
    max-width: 85%;
    overflow-wrap: anywhere;
`

const TimeLabel = styled.div`
    font-size: 10px;
    width: 60px;
    text-align: right;
    margin-top: 10px;
    margin-bottom: auto;
`

const TextBot = styled.div`
    margin-left: 30px;
    text-align: justify;
    max-width: 85%;
    overflow-wrap: anywhere;
`

const TimeLabelBot = styled.div`
    font-size: 10px;
    width: 60px;
    text-align: left;
    margin-top: 10px;
    margin-bottom: auto;
`

const ChatListContainer = styled.div`
    padding: 30px;
    border-radius: 5px;
    background-color: #f5f5f5;
    margin-bottom: 10px;
    height: 85vh;
    overflow: auto; 
    @media (max-width: 768px) {
        height: 70vh;
    }
`

const ChatboxPage = ({
    handleLogout = () => console.log('for logout')
}) => {
  const [messages, setMessages] = useState([]);
  const [messageText, setMessageText] = useState('');
  const [messageBot, setMessageBot] = useState('');
  const [disabledSend, setDisabledSend] = useState(false);
  const [error, setError] = useState('');
  const containerRef = useRef();
  const [record, setRecord] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const parseFromJson = (json) => {
      return Object.keys(json).map(key => {
          const product = json[key];
          
          return {
              value: product,
              key: key // Use the original key as a property
          };
      });
  }

  const handleSendMessage = async () => {
    setError(null);
    setDisabledSend(true);
    const cookie = Cookies.get("gen.client.authentication");
    const username = Cookies.get("gen.client.username.chatbot");
    const chatNumber = Cookies.get("gen.client.number.chatbot");

    if (cookie && username && chatNumber && record) {
        if (messageText.trim() !== '') {
            setMessages([...messages, {
                text: messageText,
                type: 'self',
                timestamp: new Date().toLocaleTimeString()
            }]);
    
            let form = JSON.stringify({
                "user_text": messageText,
                "user_id": chatNumber,
                "user_name": username,
                "kata_client_id": record.kata_client_id,
                "prompt_tag": "",
            });
        
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: process.env.REACT_APP_CHATBOT_URL,
                headers: { 
                  'Content-Type': 'application/json'
                },
                data : form
            };
        
            await axios.request(config)
                .then((response) => {
                    if (response.data && response.data.data) {
                        setMessageBot([{
                            text: response.data.data,
                            type: 'bot',
                            timestamp: new Date().toLocaleTimeString()
                        }]);
                    }
                })
                .catch((error) => {
                    setError(error.message);
                });
        }
    } else {
        setError(true);
        setTimeout(() => {
            proceedLogout()
        }, 3000)
    }
    setMessageText('');
    setDisabledSend(false);
  };

    const proceedLogout = () => {
        Cookies.remove("gen.client.authentication")
        Cookies.remove("gen.client.username.chatbot")
        Cookies.remove("gen.client.number.chatbot")
        handleLogout(false)
    }

    const checkAuthentication = () => {
        setLoading(true);
        const cookie = Cookies.get("gen.client.authentication");
        const username = Cookies.get("gen.client.username.chatbot");
        const chatNumber = Cookies.get("gen.client.number.chatbot");

        if (cookie && username && chatNumber) {
            var bytes = CryptoJS.AES.decrypt(cookie, 'my-secret-key@123');
            var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            if (decryptedData.kata_client_id) {
                setRecord({
                    ...decryptedData,
                    whitelist: decryptedData.whitelist ? parseFromJson(JSON.parse(decryptedData.whitelist)) : [{
                        key: Math.floor(100000 + Math.random() * 900000),
                        value: 'random-person'
                    }]
                })
            } else {
                proceedLogout()
            }
            setLoading(false);
        } else {
            proceedLogout()
            setLoading(false);
        }
    }

  useEffect(() => {
    setMessages([...messages, ...messageBot])
    // eslint-disable-next-line
  }, [messageBot])

  useEffect(() => {
    if (messages.length > 0 && containerRef.current) {
        containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
    // eslint-disable-next-line
  }, [messages])

  useEffect(() => {
    checkAuthentication()
    // eslint-disable-next-line
  }, [])

  return (
    <>
        {loading && <LoadingPage />}
        {error && 
        <ToastContainer>
            <Toast>
                <ToastHeader>
                    Authentication
                </ToastHeader>
                <ToastBody>
                    Session is expired, logout automatically
                </ToastBody>
            </Toast>
        </ToastContainer>
        }
        <ChatContainer>
            <Row>
                <Col sm="12">
                    {error && <Alert color="danger">{error}</Alert>}
                    <LoginTitle>
                        <KataIcon /> 
                        <h5>{record?.client_name}</h5>
                    </LoginTitle> 
                    <ChatListContainer ref={containerRef}>
                        {messages.map((message, index) => message.type === "self" ? 
                            (
                                <MessageContainer key={index}>
                                    <Text>{message.text}</Text>
                                    <TimeLabel>{message.timestamp}</TimeLabel>
                                </MessageContainer>
                            )
                            :
                            (
                                <MessageContainerBot key={index}>
                                    <TimeLabelBot>{message.timestamp}</TimeLabelBot>
                                    <TextBot>{message.text}</TextBot>
                                </MessageContainerBot>
                            )
                        )}
                    </ChatListContainer>
                </Col>
                <Col sm="12">
                    <Row>
                        <Col lg="9" sm={12}>
                            <Input
                                type="text"
                                placeholder="Type a message..."
                                value={messageText}
                                onChange={(e) => setMessageText(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && messageText !== "" && handleSendMessage()}
                            />
                        </Col>
                        <Col lg="2" sm={12}>
                            <Button color="primary" disabled={disabledSend} onClick={handleSendMessage} block>
                                Send
                            </Button>
                        </Col>
                        <Col lg="1" sm={12}>
                            <Button color="danger" disabled={disabledSend} onClick={() => {
                                Cookies.remove("gen.client.authentication")
                                Cookies.remove("gen.client.username.chatbot")
                                Cookies.remove("gen.client.number.chatbot")

                                proceedLogout()
                            }} block>
                                <FaPowerOff />
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </ChatContainer>
    </>
  );
};

export default ChatboxPage;
